import { render } from "./PagoCorrecto.vue?vue&type=template&id=95e946c2"
import script from "./PagoCorrecto.vue?vue&type=script&lang=ts"
export * from "./PagoCorrecto.vue?vue&type=script&lang=ts"
script.render = render

export default script